import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { InternalLink } from 'smartsuite-ui';
import { getSystemOrigin } from '../../../shared/hooks/linkHooks';
import DashboardContext from '../../../shared/hooks/dashboardContext';

function getTracerLink(tracerReferenceId, linkConfig, systemManifest) {
    const systemOrigin = getSystemOrigin(linkConfig, systemManifest);
    const pathname = linkConfig.pathName;

    return `${systemOrigin}${pathname}/${tracerReferenceId}`;
}

export default function TracerRecordDetailLink(props) {
    const { systemManifest } = useContext(DashboardContext);

    const tracerReferenceId = props.resultRow[props.columnConfig.idDataKey];
    const hasAccess = props.resultRow[props.columnConfig.hasAccessDataKey];

    if (!hasAccess || !tracerReferenceId) {
        return <span>{props.children}</span>;
    }

    return (
        <InternalLink
            canViewLink={true}
            href={getTracerLink(
                tracerReferenceId,
                props.columnConfig.linkConfig,
                systemManifest
            )}
            openInNewTab={props.openInNewTab}
        >
            {props.children}
        </InternalLink>
    );
}

TracerRecordDetailLink.propTypes = {
    children: PropTypes.node.isRequired,
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    openInNewTab: PropTypes.bool,
    resultRow: PropTypes.instanceOf(Object),
};

TracerRecordDetailLink.defaultProps = {
    openInNewTab: false,
};
